<template>
  <a-drawer
    :title="$t('入驻审核.审核详情')"
    :width="800"
    :visible="visible"
    :closable="true"
    @close="onClose"
  >
    <a-spin :spinning="loading">
      <a-descriptions :column="2" bordered>
        <a-descriptions-item :label="$t('入驻审核.角色类型')">
          <a-tag :color="detail.workerType === 1 ? 'blue' : detail.workerType === 2 ? 'green' : 'orange'">
            {{ detail.workerTypeName }}
          </a-tag>
        </a-descriptions-item>
        <a-descriptions-item :label="$t('入驻审核.审核状态')">
          <a-tag :color="detail.auditStatus === 0 ? 'orange' : detail.auditStatus === 1 ? 'green' : 'red'">
            {{ detail.auditStatusName }}
          </a-tag>
        </a-descriptions-item>
        
        <!-- 社区专属 -->
        <a-descriptions-item :label="$t('入驻审核.社区名称')" v-if="detail.workerType === 1">
          {{ detail.communityName }}
        </a-descriptions-item>
        
        <!-- 师傅/个体户专属 -->
        <a-descriptions-item :label="$t('入驻审核.真实姓名')" v-if="detail.workerType !== 1">
          {{ detail.realName }}
        </a-descriptions-item>
        <a-descriptions-item :label="$t('入驻审核.身份证号')" v-if="detail.workerType !== 1">
          {{ detail.idCard }}
        </a-descriptions-item>
        <a-descriptions-item :label="$t('入驻审核.联系方式')" v-if="detail.workerType !== 1">
          {{ detail.contactPhone }}
        </a-descriptions-item>
        <a-descriptions-item :label="$t('入驻审核.从业时间')" v-if="detail.workerType !== 1">
          {{ detail.workStartTime }}
        </a-descriptions-item>
        <a-descriptions-item :label="$t('入驻审核.服务技能')" v-if="detail.workerType !== 1">
          {{ detail.serviceSkillNames ? detail.serviceSkillNames.join('、') : '' }}
        </a-descriptions-item>
        <a-descriptions-item :label="$t('入驻审核.个人介绍')" v-if="detail.workerType !== 1" :span="2">
          {{ detail.introduction || '暂无' }}
        </a-descriptions-item>
        
        <!-- 通用 -->
        <a-descriptions-item :label="$t('入驻审核.地区')">
          {{ detail.province }}{{ detail.city }}{{ detail.district }}
        </a-descriptions-item>
        <a-descriptions-item :label="$t('入驻审核.详细地址')">
          {{ detail.address }}
        </a-descriptions-item>
        
        <!-- 工装头像/大门照 -->
        <a-descriptions-item :label="$t('入驻审核.工装头像/大门照')">
          <template v-if="detail.avatarImage">
            <a-avatar :size="80" :src="detail.avatarImage" @click.native="handleImagePreview(detail.avatarImage)" style="cursor: pointer;" />
          </template>
          <span v-else>暂无</span>
        </a-descriptions-item>

        <!-- 身份证照片（师傅/个体户） -->
        <a-descriptions-item :label="$t('入驻审核.身份证人面像')" v-if="detail.workerType !== 1">
          <template v-if="detail.idCardFront">
            <a-avatar :size="80" :src="detail.idCardFront" shape="square" @click.native="handleImagePreview(detail.idCardFront)" style="cursor: pointer;" />
          </template>
          <span v-else>暂无</span>
        </a-descriptions-item>
        <a-descriptions-item :label="$t('入驻审核.身份证国徽面')" v-if="detail.workerType !== 1">
          <template v-if="detail.idCardBack">
            <a-avatar :size="80" :src="detail.idCardBack" shape="square" @click.native="handleImagePreview(detail.idCardBack)" style="cursor: pointer;" />
          </template>
          <span v-else>暂无</span>
        </a-descriptions-item>
        <a-descriptions-item :label="$t('入驻审核.手持身份证')" v-if="detail.workerType !== 1">
          <template v-if="detail.idCardHand">
            <a-avatar :size="80" :src="detail.idCardHand" shape="square" @click.native="handleImagePreview(detail.idCardHand)" style="cursor: pointer;" />
          </template>
          <span v-else>暂无</span>
        </a-descriptions-item>
        
        <!-- 保证金 -->
        <a-descriptions-item :label="$t('入驻审核.保证金状态')">
          <a-tag :color="detail.depositStatus === 1 ? 'green' : 'red'">{{ detail.depositStatusName }}</a-tag>
        </a-descriptions-item>
        <a-descriptions-item :label="$t('入驻审核.已缴纳保证金')">
          {{ detail.depositAmount }}
        </a-descriptions-item>
        
        <!-- 工作状态 -->
        <a-descriptions-item :label="$t('入驻审核.工作状态')">
          <a-tag :color="detail.workStatus === 1 ? 'green' : 'gray'">{{ detail.workStatusName }}</a-tag>
        </a-descriptions-item>
        <a-descriptions-item :label="$t('入驻审核.服务评价')">
          {{ detail.rating }} 分
        </a-descriptions-item>
        
        <!-- 审核信息 -->
        <a-descriptions-item :label="$t('入驻审核.审核备注')" v-if="detail.auditRemark">
          {{ detail.auditRemark }}
        </a-descriptions-item>
        <a-descriptions-item :label="$t('入驻审核.审核时间')" v-if="detail.auditTime">
          {{ parseTime(detail.auditTime) }}
        </a-descriptions-item>
        
        <!-- 社区审核列表（个体户） -->
        <a-descriptions-item :label="$t('入驻审核.社区审核列表')" :span="2" v-if="detail.workerType === 3 && detail.communityAuditList">
          <a-table :columns="communityColumns" :data-source="detail.communityAuditList" :pagination="false" size="small" rowKey="relId">
            <span slot="auditStatus" slot-scope="text, record">
              <a-tag :color="record.auditStatus === 0 ? 'orange' : record.auditStatus === 1 ? 'green' : 'red'">
                {{ record.auditStatusName }}
              </a-tag>
            </span>
          </a-table>
        </a-descriptions-item>
        
        <a-descriptions-item :label="$t('入驻审核.申请时间')">
          {{ parseTime(detail.createTime) }}
        </a-descriptions-item>
        <a-descriptions-item :label="$t('入驻审核.备注')">
          {{ detail.remark }}
        </a-descriptions-item>
      </a-descriptions>
    </a-spin>
  </a-drawer>
</template>

<script>
import { getWorker } from '@/api/homeworker/worker'

export default {
  name: 'DetailForm',
  data() {
    return {
      visible: false,
      loading: false,
      detail: {},
      communityColumns: [
        { title: this.$t('入驻审核.社区名称'), dataIndex: 'communityName' },
        { title: this.$t('入驻审核.审核状态'), dataIndex: 'auditStatus', scopedSlots: { customRender: 'auditStatus' } },
        { title: this.$t('入驻审核.审核备注'), dataIndex: 'auditRemark' }
      ]
    }
  },
  methods: {
    show(id) {
      this.visible = true
      this.loading = true
      getWorker(id).then(response => {
        this.detail = response.data
        this.loading = false
      })
    },
    onClose() {
      this.visible = false
    },
    handleImagePreview(url) {
      this.$info({
        title: '图片预览',
        content: (h) => h('img', { attrs: { src: url, style: 'max-width: 100%; max-height: 400px;' } }),
        width: 600,
        okText: '关闭'
      })
    }
  }
}
</script>

<style scoped>
/* 图片预览弹窗样式 */
</style>
